import { Navigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetOfferDetailsQuery } from '@app/api/investmentsApi';
import { PageLoader } from '@app/components/PageLoader';
import { ROUTES } from '@app/configs/routes';
import InvestmentForm from './components/InvestmentForm';
import MainDetails from './components/MainDetails';
const ViewAndInvest = ({ isStandalone }) => {
    const { t } = useTranslation();
    const { id } = useParams();
    const { data: selectedInvestment, isLoading: loadingDetails, isFetching: fetchingDetails, error: detailsError, refetch: refetchInvestmentDetails, } = useGetOfferDetailsQuery(Number(id), {
        skip: !id,
    });
    if (loadingDetails && !detailsError) {
        return <PageLoader />;
    }
    if (detailsError) {
        return <Navigate to={isStandalone ? ROUTES.investorStart : ROUTES.home}/>;
    }
    return (<div className="flex flex-col gap-6 w-full">
            <h1 className="headline-m text-neutral-primary-initial">
                {t('financing.investment_details.view_and_invest')}
            </h1>
            <InvestmentForm details={selectedInvestment} refetchInvestmentDetails={refetchInvestmentDetails} loadingDetails={fetchingDetails}>
                <MainDetails details={selectedInvestment}/>
            </InvestmentForm>
        </div>);
};
export default ViewAndInvest;
